"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAllWinningBids = exports.getWinningBidForAd = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _lang = require("lodash/lang");

var _object = require("lodash/object");

var _getBidders = _interopRequireDefault(require("../getBidders"));

var _config = require("../config");

var _storage = require("./storage");

var _BidResponse = _interopRequireDefault(require("./BidResponse"));

var _DisplayedAdInfo = _interopRequireDefault(require("./DisplayedAdInfo"));

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2.default)(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/**
 * Get the Google Ad Manager advertiser ID of the advertiser that
 * has displayed an ad.
 * @param {String} adId - An ad ID.
 * @return {Number|null} The Google Ad Manager advertiser ID.
 */


var getGAMAdvertiserIdForDisplayedAd = function getGAMAdvertiserIdForDisplayedAd(adId) {
  var store = (0, _storage.getAdDataStore)();
  var slot = (0, _object.get)(store, ['adManager', 'slotsRendered', adId]); // If there's no data, the slot has not rendered, so there is
  // no winning bid.

  if (!slot) {
    return null;
  } // AdSense will not have an ID or will have an ID of zero. We use 99.


  var DEFAULT_ADVERTISER_ID = 99;
  var GAMAdvertiserId = (0, _object.get)(slot, 'advertiserId', null) || DEFAULT_ADVERTISER_ID;
  return GAMAdvertiserId;
};
/**
 * Get the Google Ad Manager ad slot ID of the displayed ad.
 * @param {String} adId - An ad ID.
 * @return {Number|null} The Google Ad Manager ad slot ID.
 */


var getGAMAdUnitId = function getGAMAdUnitId(adId) {
  var store = (0, _storage.getAdDataStore)();
  var renderedSlotData = (0, _object.get)(store, ['adManager', 'slotsRendered', adId]); // If there's no data, the slot has not rendered, so there is
  // no winning bid.

  if (!renderedSlotData) {
    return null;
  }

  var adUnitId = renderedSlotData.slot.getAdUnitPath();
  return adUnitId;
};
/**
 * Get the winning BidResponse for the ad with ID `adId`, merging any
 * encodedRevenue value with the top revenue value.
 * @param {String} adId - An ad ID.
 * @return {Object|null} A BidResponse, the winning bid for this ad,
 *   or null if there is no bid.
 */


var getTopBidForAd = function getTopBidForAd(adId) {
  var store = (0, _storage.getAdDataStore)();
  var bidders = (0, _getBidders.default)();
  var allBidsForAd = bidders.reduce(function (acc, bidder) {
    // If the bidder did not respond in time to be part of the
    // ad server request, don't consider their bids.
    if (!(0, _object.get)(store, ['bidResponses', bidder.name, 'includedInAdRequest'])) {
      return acc;
    }

    var bidsForBidder = (0, _object.get)(store, ['bidResponses', bidder.name, 'bidResponses', adId]);
    return acc.concat(bidsForBidder);
  }, []); // We get both the top unencoded revenue bid response and any
  // encoded revenue bid response. We want to send both the revenue
  // and encodedRevenue values because we don't know which is
  // higher. Note that this only works because we know we only have
  // one bidder with encoded revenue values.

  var topBids = allBidsForAd.reduce(function (acc, bid) {
    var newAcc = {
      topRevenueBid: _objectSpread({}, acc.topRevenueBid),
      encodedRevenueBid: _objectSpread({}, acc.encodedRevenueBid)
    }; // If this bid has a higher revenue value, set it as the new
    // top-revenue bid. Note that this only works because we know we
    // only have one bidder with encoded revenue values.

    if ((0, _object.get)(bid, 'revenue', 0) > (0, _object.get)(acc, 'topRevenueBid.revenue', 0)) {
      newAcc.topRevenueBid = bid;
    } // If this bid has an encodedRevenue value, set it as the bid
    // with encodedRevenue.


    if ((0, _object.get)(bid, 'encodedRevenue')) {
      newAcc.encodedRevenueBid = bid;
    }

    return newAcc;
  }, {
    topRevenueBid: {},
    encodedRevenueBid: {}
  }); // Combine the top revenue bid with the encoded revenue bid.

  var encodedRevenue = (0, _object.get)(topBids, 'encodedRevenueBid.encodedRevenue', null);

  var mergedBid = _objectSpread(_objectSpread(_objectSpread({}, (0, _object.get)(topBids, 'encodedRevenueBid', {})), (0, _object.get)(topBids, 'topRevenueBid', {})), encodedRevenue && {
    encodedRevenue: encodedRevenue
  });

  if ((0, _lang.isEmpty)(mergedBid)) {
    return null;
  }

  return (0, _BidResponse.default)(mergedBid);
};
/**
 * Get the winning DisplayedAdInfo data for the ad with ID `adId`.
 * @param {String} adId - An ad ID.
 * @return {Object|null} A DisplayedAdInfo, the winning bid for this ad,
 *   or null if an ad hasn't been displayed.
 */


var getWinningBidForAd = function getWinningBidForAd(adId) {
  var GAMAdvertiserId = getGAMAdvertiserIdForDisplayedAd(adId);

  if (!GAMAdvertiserId) {
    return null;
  }

  var GAMAdUnitId = getGAMAdUnitId(adId);
  var topBid = getTopBidForAd(adId);

  if (!topBid) {
    return null;
  }

  return (0, _DisplayedAdInfo.default)(_objectSpread(_objectSpread({}, topBid), {}, {
    adId: adId,
    GAMAdvertiserId: GAMAdvertiserId,
    GAMAdUnitId: GAMAdUnitId
  }));
};
/**
 * Get the winning DisplayedAdInfo data for each ad ID
 * @param {String} adId - An ad ID.
 * @return {Object} An object with keys equal to ad IDs, each with
 *   value DisplayedAdInfo or null
 */


exports.getWinningBidForAd = getWinningBidForAd;

var getAllWinningBids = function getAllWinningBids() {
  var tabConfig = (0, _config.getConfig)();
  var adUnits = (0, _object.get)(tabConfig, 'adUnits', []);
  var winningBidsByAd = adUnits.reduce(function (acc, adUnit) {
    return _objectSpread(_objectSpread({}, acc), {}, (0, _defineProperty2.default)({}, adUnit.adId, getWinningBidForAd(adUnit.adId)));
  }, {});
  return winningBidsByAd;
};

exports.getAllWinningBids = getAllWinningBids;